import { Components, Theme } from '@mui/material';

declare module '@mui/material/TableCell' {
  interface TableCellPropsColorOverrides {
    primary: true;
  }
}

export const MuiTableCell: Components<
  Omit<Theme, 'components'>
>['MuiTableCell'] = {
  styleOverrides: {
    root: {
      padding: '8px 16px',
      fontSize: '14px',
      div: {
        display: 'inline-flex',
        alignItems: 'center',
        columnGap: '8px',
      },
    },
  },
  variants: [
    {
      props: { color: 'primary' },
      style: ({ theme }: { theme: Theme }) => ({
        color: theme.palette.primary.main,
        cursor: 'pointer',
      }),
    },
  ],
};
